import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    effect,
    ElementRef,
    EventEmitter,
    input,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
    ViewRef,
} from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25LoadingApi } from "../../s25-loading/loading.api";

@TypeManagerDecorator("generic-table-simple-select")
@Component({
    selector: "generic-table-simple-select",
    template: `
        <s25-loading-inline [model]="{}"></s25-loading-inline>
        <div class="select-wrapper" [class.has-error]="errorMsg?.()">
            @if (!isLoading?.()) {
                <select [(ngModel)]="modelValue" (ngModelChange)="onUpdate()" class="cn-form__control">
                    @for (option of options; track $index) {
                        <option [value]="option.value" [disabled]="!!option.disabled">{{ option.label }}</option>
                    }
                </select>
                @if (errorMsg()) {
                    <p class="error-message">{{ errorMsg() }}</p>
                } @else if (infoMsg?.()) {
                    <p class="ngFinePrint">{{ infoMsg() }}</p>
                }
            }
        </div>
    `,
    styles: `
        ::ng-deep .nm-party--on .error-message {
            color: #ff837b;
        }

        ::ng-deep body#s25.nm-party--on .has-error select.cn-form__control,
        body.nm-party--on .has-error select.cn-form__control,
        html.nm-party--on .has-error select.cn-form__control {
            border-bottom-color: #ff837b !important;
        }

        .select-wrapper {
            display: flex;
            flex-direction: column;
            width: fit-content;
        }

        .has-error {
            position: relative;
            top: 11px;
            margin-bottom: 5px;
        }

        .has-error select {
            border-bottom: 2px solid red !important;
        }

        .error-message {
            color: red;
            font-size: 0.8rem;
            text-wrap: nowrap;
        }

        s25-loading-inline {
            margin: 0;
        }

        .ngFinePrint {
            max-width: 20em;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GenericTableSimpleSelectComponent implements OnInit {
    @Input() modelValue: string | number;
    @Input() options: { value: string | number; label: string; disabled?: boolean }[];
    @Input() resetAfterSelection: boolean;
    errorMsg = input<string>(null);
    infoMsg = input<string>(null);
    isLoading = input(false);

    @Output() modelValueChange = new EventEmitter<string | number>();

    originalValue: string | number;

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
    ) {
        effect(() => {
            if (this.isLoading?.()) {
                S25LoadingApi.init(this.elementRef.nativeElement);
            } else {
                S25LoadingApi.destroy(this.elementRef.nativeElement);
            }
        });
    }

    ngOnInit() {
        this.originalValue = this.modelValue;
    }

    onUpdate() {
        this.modelValueChange.emit(this.modelValue);
        this.resetAfterSelection &&
            setTimeout(() => {
                // reset dropdown after selection made unless view is destroyed
                if (!(this.cd as ViewRef)?.destroyed) {
                    this.modelValue = this.originalValue;
                    this.cd.markForCheck();
                }
            }, 1000);
    }
}
